import { useEffect, useState } from "react";
import ModalComponent from "../../reusableComponents/modal";
import AddLookupForm from "./addLookup";
import DeleteLookup from "./deleteLookup";

const LookupsAlerts = ({
  modalVisible,
  setModalVisible,
  userToken,
  selectedLookup,
}) => {
  const { addLookup, deleteLookup, editLookup, helperData } = modalVisible;

  return (
    <>
      {addLookup && (
        <ModalComponent
          hasImage={
            <img
              src={"/assets/images/addLookup.png"}
              width={"100%"}
              height={"100%"}
            />
          }
          title={"إضافة"}
          modalVisible={addLookup}
          setModalVisible={() => {
            setModalVisible({ ...modalVisible, addLookup: !addLookup });
          }}
          body={
            <AddLookupForm
              userToken={userToken}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              selectedLookup={selectedLookup}
            />
          }
        ></ModalComponent>
      )}
      {editLookup && (
        <ModalComponent
          title={"تعديل"}
          modalVisible={editLookup}
          setModalVisible={() => {
            setModalVisible({
              ...modalVisible,
              editLookup: !editLookup,
              helperData: null,
            });
          }}
          hasImage={
            <img
              src="/assets/images/greeniconedit.svg"
              width={20}
              height={20}
              alt=""
            />
          }
          body={
            <AddLookupForm
              userToken={userToken}
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              selectedLookup={selectedLookup}
              isEdit
            />
          }
        ></ModalComponent>
      )}
      {deleteLookup && (
        <ModalComponent
          modalVisible={deleteLookup}
          setModalVisible={() => {
            setModalVisible({
              ...modalVisible,
              deleteLookup: !deleteLookup,
            });
          }}
          body={
            <DeleteLookup
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              selectedLookup={selectedLookup}
            />
          }
          size={"s"}
          hasImage={
            <img
              src="/assets/images/deleteicon.png"
              width={20}
              height={20}
              alt=""
            />
          }
          title={"هل انت متاكد"}
          background={"modalBackground mx-5"}
        />
      )}
    </>
  );
};

export default LookupsAlerts;
